var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "callout",
    {
      staticClass: "mb-3",
      attrs: {
        "border-color": _vm.statusLayout.borderColor,
        controlled: true,
        "has-gradient": "",
        "has-toggle": true,
        opened: _vm.isCalloutOpen
      },
      on: { "click:open": _vm.toggleHistorySection }
    },
    [
      _c("div", { staticClass: "row info-container" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-2 info-container__balloon" },
          [
            _c("custom-balloon", {
              staticClass: "w-100 mt-3 mt-md-0 mx-0",
              attrs: {
                "background-color": _vm.statusLayout.color,
                text: _vm.document.proposalDocumentStatusName
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-md-10" },
          [
            _c("document-info", {
              attrs: {
                "add-file": _vm.canBeSubmitted,
                "can-replace-denied": _vm.statusLayout.isDenied,
                "can-replace-requested": _vm.statusLayout.isRequestReplacement,
                "can-request-replacement-approved": _vm.canRequestReplacement,
                document: _vm.document,
                "document-title": "Tipo de Documento:",
                "file-preview": _vm.canShowFilePreview && !_vm.canEditDocuments,
                "show-action-btn": _vm.canManageDocument,
                "show-filename": ""
              },
              on: {
                manageDocumentStatus: _vm.manageDocumentStatus,
                "on-upload-file": _vm.onUploadFile,
                "request-replacement": _vm.openRequestReplacement
              }
            })
          ],
          1
        )
      ]),
      _c("div", { attrs: { slot: "edition" }, slot: "edition" }, [
        _c("div", { staticClass: "bg-secondary-3 p-2" }, [
          _c(
            "div",
            { staticClass: "bg-white rounded p-4" },
            [
              _vm.showStatusHisotry
                ? _c("ContractDocumentStatusHistory", {
                    attrs: { history: _vm.statusHistory },
                    on: { "fetch-history": _vm.fetchHistory }
                  })
                : _vm.showDenyForm
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 mb-3" }, [
                      _c("em", {
                        staticClass: "fas fa-bell-exclamation text-orange mr-1"
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "color-gray-7 font-weight-bold font-16"
                        },
                        [_vm._v(" Razón para Denegar ")]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-7 mb-3 mb-md-0" },
                      [
                        _c(
                          "validation-observer",
                          { ref: "proposalContractDocuments" },
                          [
                            _c("validation-provider", {
                              attrs: { name: "Archivo", rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-input", {
                                        attrs: {
                                          "custom-error-msg":
                                            "Este campo es requerido para continuar con el proceso.",
                                          error: errors[0],
                                          label: "Razón:",
                                          maxlength: "3000",
                                          type: "text"
                                        },
                                        model: {
                                          value: _vm.razonByDenyDocument,
                                          callback: function($$v) {
                                            _vm.razonByDenyDocument = $$v
                                          },
                                          expression: "razonByDenyDocument"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-5 d-flex justify-content-end align-items-end"
                      },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              id: "modal-btn-cancelar",
                              i: "fas fa-times-circle",
                              variant: "outline-danger mr-2"
                            },
                            on: {
                              click: function($event) {
                                _vm.isCalloutOpen = false
                              }
                            }
                          },
                          [_vm._v(" Cancelar ")]
                        ),
                        _c(
                          "action-button",
                          {
                            attrs: { i: "fa fa-save", variant: "success px-3" },
                            on: {
                              click: function($event) {
                                return _vm.denyContractDocument()
                              }
                            }
                          },
                          [_vm._v(" Guardar ")]
                        )
                      ],
                      1
                    )
                  ])
                : _vm.showRequestReplacementForm
                ? _c(
                    "div",
                    [
                      _c("ContractDocumentReplacement", {
                        on: {
                          cancel: _vm.closeRequestReplacement,
                          confirm: _vm.handleConfirmReplacement
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }